// Mock data for Four Pillars Global LLP Poultry Farm

export const mockData = {
  company: {
    name: "Four Pillars Global LLP",
    brandName: "Eggfy",
    tagline: "Premium Quality Eggs from Automated Layer Farming",
    established: "2026",
    location: "India",
    description: "Leading provider of fresh, high-quality eggs through state-of-the-art automated poultry farming technology."
  },

  hero: {
    title: "Premium Quality Eggs Through Modern Automation",
    subtitle: "Eggfy by Four Pillars Global LLP - Where Technology Meets Tradition",
    description: "India's most advanced automated egg layer farm, delivering farm-fresh quality eggs with sustainable practices.",
    cta: {
      primary: "Request Quote",
      secondary: "Explore Our Farm"
    }
  },

  about: {
    title: "About Four Pillars Global LLP",
    subtitle: "Pioneering Excellence in Automated Poultry Farming",
    description: "Established in 2026, Four Pillars Global LLP represents the future of poultry farming in India. We combine cutting-edge automation technology with sustainable farming practices to deliver the highest quality eggs to both B2B partners and direct consumers.",
    stats: [
      { value: "62,000+", label: "Layers", icon: "Bird" },
      { value: "60,000+", label: "Eggs Daily", icon: "Egg" },
      { value: "100%", label: "Automated", icon: "Zap" },
      { value: "5-Star", label: "Quality Rating", icon: "Star" }
    ],
    features: [
      {
        title: "Automated Climate Control",
        description: "Advanced HVAC systems ensure optimal conditions for layer health and productivity year-round.",
        icon: "Thermometer"
      },
      {
        title: "Smart Feeding Systems",
        description: "Precision-controlled nutrition delivery ensures consistent egg quality and layer wellbeing.",
        icon: "Settings"
      },
      {
        title: "Quality Assurance",
        description: "Rigorous testing and monitoring at every stage from farm to packaging.",
        icon: "Shield"
      },
      {
        title: "Sustainable Practices",
        description: "Eco-friendly operations with waste recycling and renewable energy integration.",
        icon: "Leaf"
      }
    ]
  },

  products: [
    {
      id: 1,
      name: "Eggfy Premium White Eggs",
      description: "Farm-fresh white eggs with superior shell strength and rich yolk. Perfect for all culinary needs.",
      grade: "Grade A",
      sizes: ["Medium", "Large", "Extra Large"],
      features: ["High Protein", "Fresh Daily", "Quality Tested"],
      minOrder: "300 eggs",
      icon: "Circle"
    },
    {
      id: 2,
      name: "Eggfy Premium Brown Eggs",
      description: "Nutrient-rich brown eggs from free-range layers. Preferred by health-conscious consumers.",
      grade: "Grade A",
      sizes: ["Medium", "Large", "Extra Large"],
      features: ["Rich Nutrients", "Free Range", "Organic Feed"],
      minOrder: "300 eggs",
      icon: "Circle"
    },
    {
      id: 3,
      name: "Eggfy Organic Premium Eggs",
      description: "100% organic certified eggs from layers fed with certified organic feed in optimal conditions.",
      grade: "Grade AA",
      sizes: ["Large", "Extra Large"],
      features: ["Certified Organic", "No Antibiotics", "Premium Quality"],
      minOrder: "200 eggs",
      icon: "Award"
    }
  ],

  farmTechnology: {
    title: "Our Advanced Farm Technology",
    subtitle: "Powered by Advanced Gartech Layer Farm Equipment — GE ULTIMA AIR",
    technologies: [
      {
        title: "Gartech GE ULTIMA AIR System",
        description: "Advanced Gartech layer farm equipment with the GE ULTIMA AIR system, delivering superior ventilation, bird comfort, and consistent egg production at scale.",
        icon: "Wind"
      },
      {
        title: "Lark Engineering In-House Feed Mill (6-10 TPH)",
        description: "Lark Engineering in-house feed mill with 6-10 TPH capacity produces fresh, precisely formulated feed on-site, ensuring complete quality control and optimal layer nutrition.",
        icon: "Factory"
      },
      {
        title: "Automated Feeding & Watering",
        description: "Computer-controlled systems deliver precise nutrition and fresh water 24/7, ensuring optimal health and productivity.",
        icon: "Droplets"
      },
      {
        title: "Climate Management",
        description: "Smart sensors and HVAC systems maintain perfect temperature and humidity for maximum comfort and egg production.",
        icon: "Wind"
      },
      {
        title: "Egg Collection System",
        description: "Gentle automated collection with conveyor systems minimizes handling and ensures eggs reach packaging fresh and intact.",
        icon: "Package"
      },
      {
        title: "Health Monitoring",
        description: "AI-powered cameras and sensors track layer health, detect issues early, and ensure flock wellbeing.",
        icon: "Activity"
      },
      {
        title: "Waste Management",
        description: "Automated waste removal and composting systems maintain hygiene while creating organic fertilizer.",
        icon: "Recycle"
      },
      {
        title: "Power Backup",
        description: "Dual power supply with solar integration and generators ensure uninterrupted operations.",
        icon: "Battery"
      }
    ]
  },

  testimonials: [
    {
      id: 1,
      name: "Rajesh Kumar",
      role: "Restaurant Chain Owner",
      company: "Golden Spoon Restaurants",
      content: "Four Pillars Global has been our trusted egg supplier for 6 months. The consistency in quality and freshness is unmatched. Their automated farming ensures we get the same premium quality every single day.",
      rating: 5
    },
    {
      id: 2,
      name: "Priya Sharma",
      role: "Procurement Manager",
      company: "FreshMart Supermarkets",
      content: "We've partnered with Four Pillars Global for our organic egg section. Customer feedback has been outstanding. The traceability and quality certifications give our customers confidence.",
      rating: 5
    },
    {
      id: 3,
      name: "Mohammed Ali",
      role: "Bakery Owner",
      company: "Ali's Premium Bakery",
      content: "As a baker, egg quality directly impacts my products. Four Pillars delivers eggs with perfect yolk color, shell strength, and freshness. My cakes and pastries have never been better!",
      rating: 5
    }
  ],

  gallery: [
    {
      id: 1,
      title: "Modern Automated Facility",
      category: "Infrastructure",
      image: "https://images.pexels.com/photos/27083552/pexels-photo-27083552.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
    },
    {
      id: 2,
      title: "Advanced Layer Housing — Gartech GE ULTIMA AIR",
      category: "Infrastructure",
      image: "/equipment/gartech-ultima-air-3.webp"
    },
    {
      id: 3,
      title: "Smart Farm Technology — Gartech EC Control",
      category: "Technology",
      image: "/equipment/gartech-ultima-air-4.webp"
    },
    {
      id: 4,
      title: "Premium Quality Eggs",
      category: "Products",
      image: "https://images.pexels.com/photos/4110226/pexels-photo-4110226.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
    },
    {
      id: 5,
      title: "Fresh Egg Selection",
      category: "Products",
      image: "https://images.pexels.com/photos/29802845/pexels-photo-29802845.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
    },
    {
      id: 6,
      title: "Organic Farm Fresh",
      category: "Products",
      image: "https://images.unsplash.com/photo-1765252582326-d5768f3325aa"
    },
    {
      id: 7,
      title: "Quality Assurance",
      category: "Quality",
      image: "https://images.pexels.com/photos/34439458/pexels-photo-34439458.jpeg"
    },
    {
      id: 8,
      title: "Healthy Happy Layers",
      category: "Farm Life",
      image: "https://images.unsplash.com/photo-1623877111394-4d1ee8b558c3"
    },
    {
      id: 9,
      title: "Production Excellence",
      category: "Products",
      image: "https://images.unsplash.com/photo-1661354132156-dbe47c7f9038"
    }
  ],

  certifications: [
    { name: "ISO 22000", description: "Food Safety Management" },
    { name: "FSSAI Licensed", description: "Food Standards Compliance" },
    { name: "Organic Certified", description: "Certified Organic Production" },
    { name: "Quality Assured", description: "Grade A Certification" }
  ],

  contact: {
    email: "sales@eggfy.in",
    phone: "+91 9811140085",
    whatsapp: "+91 9811140085",
    address: "Four Pillars Global LLP, Village Dulaghra, Bulandshahar, Uttar Pradesh, India - 203001",
    hours: "Mon - Sat: 8:00 AM - 6:00 PM",
    mapLocation: {
      lat: 28.4089,
      lng: 77.8498
    }
  },

  faqs: [
    {
      question: "What makes your eggs different from regular market eggs?",
      answer: "Our eggs come from automated climate-controlled farms with precision nutrition and health monitoring. This ensures consistent quality, freshness, and nutritional value that far exceeds conventional farming."
    },
    {
      question: "What is the minimum order quantity?",
      answer: "For premium white and brown eggs, the minimum order is 300 eggs. For organic eggs, it's 200 eggs. We cater to both bulk B2B orders and smaller direct consumer purchases."
    },
    {
      question: "Do you deliver across India?",
      answer: "Currently, we serve Pune and surrounding regions within Maharashtra. We're expanding our delivery network and will soon cover major cities across India."
    },
    {
      question: "Are your organic eggs certified?",
      answer: "Yes, our organic eggs are certified by recognized organic certification bodies. Our layers are fed 100% certified organic feed with no antibiotics or synthetic additives."
    },
    {
      question: "How do you ensure egg freshness?",
      answer: "Our automated collection system gathers eggs multiple times daily. They're immediately moved to temperature-controlled storage and dispatched within 24-48 hours of laying."
    }
  ]
};

// Form submission handler (mock)
export const handleContactForm = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Form submitted (MOCK):', formData);
      const submissions = JSON.parse(localStorage.getItem('contactSubmissions') || '[]');
      submissions.push({ ...formData, timestamp: new Date().toISOString() });
      localStorage.setItem('contactSubmissions', JSON.stringify(submissions));
      resolve({ success: true, message: 'Thank you! We will contact you within 24 hours.' });
    }, 1000);
  });
};

export const handleQuoteRequest = (quoteData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Quote requested (MOCK):', quoteData);
      const quotes = JSON.parse(localStorage.getItem('quoteRequests') || '[]');
      quotes.push({ ...quoteData, timestamp: new Date().toISOString(), quoteId: `QT${Date.now()}` });
      localStorage.setItem('quoteRequests', JSON.stringify(quotes));
      resolve({ 
        success: true, 
        message: 'Quote request received! Our team will send you a detailed quote within 24 hours.',
        quoteId: `QT${Date.now()}`
      });
    }, 1000);
  });
};
